<template>
    <v-navigation-drawer v-if="!isMobile" app right permanent width="300" color="surface" class="agenda-panel">
        <agenda-panel-body />
    </v-navigation-drawer>

    <div v-else class="agenda-panel--mobile">
        <agenda-panel-body />
    </div>
</template>

<script>
import AgendaPanelBody from "@/components/coach/agenda/AgendaPanelBody";

export default {
    name: "HomeAgendaPanel",
    components: { AgendaPanelBody },
}
</script>

<style scoped>
.agenda-panel ::v-deep .v-navigation-drawer__border {
    width: 2px !important;
    background-color: var(--v-outline-base) !important;
}

.agenda-panel--mobile {
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 14px;
    overflow: hidden;
    margin-top: 24px;
}
</style>
